import { render, staticRenderFns } from "./ShelfList.vue?vue&type=template&id=47788b5a&scoped=true"
import script from "./ShelfList.vue?vue&type=script&lang=js"
export * from "./ShelfList.vue?vue&type=script&lang=js"
import style0 from "./ShelfList.vue?vue&type=style&index=0&id=47788b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47788b5a",
  null
  
)

export default component.exports